module.exports = __webpack_public_path__ + "static/media/foodimage.c40966aa.jpg";